<div id="dialog" [class]="'relative ' + position" [ngClass]="{ 'px-10': hasPadding, 'full': fullPage }">
  <cds-svg-icon *ngIf="closable" name="cross" class="sticky top-6 -mr-4 h-0 flex justify-end" (debounceClick)="close.emit(true)"></cds-svg-icon>
  <ng-content></ng-content>
</div>
